"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginAgainButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _basis = require("basis");

var _TextContent = require("../text-content/TextContent");

var _hooks = require("../../hooks");

var _types = require("../../types");

// @ts-ignore
var LoginAgainButton = function LoginAgainButton() {
  var _useContextSelector = (0, _hooks.useContextSelector)(function (ctx) {
    return ctx.config;
  }),
      onEvent = _useContextSelector.onEvent,
      showLoginAgainLink = _useContextSelector.showLoginAgainLink;

  var trackEvent = (0, _hooks.useEventTracker)();

  if (!showLoginAgainLink) {
    return null;
  }

  var handleOnClick = function handleOnClick(evt) {
    evt.preventDefault();
    trackEvent({
      action: 'poi-bank-connect',
      label: 'common.linkLoginToDifferentBank'
    });
    onEvent({
      type: _types.FiConnectEventTypes.RESET
    });
  };

  return /*#__PURE__*/_react.default.createElement(_basis.Container, {
    margin: "10 0 0 0",
    textAlign: "center"
  }, /*#__PURE__*/_react.default.createElement(_basis.Link, {
    href: "",
    onClick: handleOnClick,
    color: "white",
    newTab: false
  }, /*#__PURE__*/_react.default.createElement(_TextContent.TextContent, {
    path: "common.linkLoginToDifferentBank"
  })));
};

exports.LoginAgainButton = LoginAgainButton;